import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { ArrowRight } from '@next-nx/shared-ui/icons'
import { Button } from '@next-nx/shared-ui/atoms'
import styles from './BoxLink.module.sass'


interface Props {
  item: MenuItemType
  ctaVariant?: 'ghost' | 'primary' | 'secondary'
  size?: 'sm' | 'md'
  className?: string
  editMode?: boolean
  handleTracking?: () => void
}

const BoxLink = (props: Props) => {

  const { 
    item = undefined,
    ctaVariant = 'ghost',
    size = 'md',
    className = '',
    editMode = false,
    handleTracking = () => undefined,
  } = props

  return item ? (
    <div className={`${styles.root} ${styles[`root--${size}`]} ${className}`}>
      <div className={styles.content}>
        {!!item.name && (
          editMode || (typeof item.name !== 'string')
          ? <div className={styles.title}>{item.name}</div>
          : <p className={styles.title}>{item.name}</p>
        )}
        {!!item.url && !!item.ctaLabel && (
          <div className={styles.ctaBox}>
            <Button href={item.url} newPage={item.blank} label={item.ctaLabel} color="white" variant={ctaVariant} icon={<ArrowRight />} iconPos="right" handleTracking={handleTracking} />
          </div>
        )}
      </div>
    </div>
  ) : <></>
}

export default BoxLink
